import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterContentInit, Component, ElementRef, EventEmitter, Input,
  OnDestroy, OnInit, Output, Renderer2, TemplateRef, ViewChild,
  ViewEncapsulation, AfterViewChecked
} from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ICON_SETTINGS, IconSettingsService, IconsModule, IconsService,
  KENDO_ICONS, KENDO_SVGICON, SVGIcon
} from '@progress/kendo-angular-icons';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ListViewModule } from "@progress/kendo-angular-listview";
import { ButtonsModule, KENDO_BUTTONS, KENDO_DROPDOWNBUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_LABELS, LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { Subscription } from 'rxjs';
import { changeManuallyIcon, moreVerticalIcon, tableCellDeleteIcon } from '@progress/kendo-svg-icons';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { KENDO_EDITOR } from '@progress/kendo-angular-editor';
import { GridModule } from '@progress/kendo-angular-grid';
import { PagerModule } from '@progress/kendo-angular-pager';
import { SafeHtml } from '@angular/platform-browser';
import { FabAlign } from "@progress/kendo-angular-buttons";
import { DialogCloseResult, DialogModule, DialogService, WindowModule, WindowService } from '@progress/kendo-angular-dialog';
import { KENDO_POPUP, PopupRef, PopupService } from '@progress/kendo-angular-popup';
import { EmojiContentComponent } from '../../shared/emoji/emoji-content/emoji-content.component';
import { ConfirmModalComponent } from '../../common-components/confirm-modal/confirm-modal.component';
import { LoggerService } from '../../shared/logger.service';
import { MeService } from '../../auth/me.service';
import { AuthTokenService } from '../../auth/auth-token.service';
import {
  CasiUserStoryComment, User as UserModel
} from '../../models/models.lib';
import { CasiCloseOptions } from '../../common/constants.lib';
import { User } from '../../auth/me.lib';
import { TokenSwapPipe } from '../../pipes/token-swap.pipe';
import { ImgZoomPipe } from '../../pipes/img-zoom.pipe';
import { CasiKendoEditorComponent } from '../../common-components/casi-kendo-editor/casi-kendo-editor.component';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

@Component({
  selector: 'casi-user-story-comment',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    ListViewModule,
    LayoutModule,
    InputsModule,
    FormsModule,
    ReactiveFormsModule,
    WindowModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    FontAwesomeModule,
    GridModule,
    PagerModule,
    KENDO_EDITOR,
    KENDO_DROPDOWNS,
    KENDO_LABELS,
    KENDO_BUTTONS,
    KENDO_DROPDOWNBUTTON,
    KENDO_POPUP,
    KENDO_ICONS,
    KENDO_SVGICON,
    // DatePipe,
    ConfirmModalComponent,
    TokenSwapPipe,
    CasiKendoEditorComponent,
    SafeHtmlPipe,
    ImgZoomPipe
  ],
  providers: [
    IconSettingsService,
    IconsService,
    {
      provide: ICON_SETTINGS,
      useValue: {
        type: "svg",
        size: "default",
      },
    },
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './user-story-comment.component.html',
  styleUrl: './user-story-comment.component.scss'
})
export class UserStoryCommentComponent implements OnInit, OnDestroy, AfterContentInit, AfterViewChecked {
  private popupRef: PopupRef | undefined;

  //#region Input/Outputs

  private _comment: CasiUserStoryComment | undefined;
  @Input({ required: true })
  set currentComment(val: CasiUserStoryComment) {
    this._comment = val;
    // this.logger.debug(`input:comment: `, this._comment);
    this.form.patchValue(this._comment);
    // this.selectedEmoji = this.comment.emoji;
  }
  get currentComment() {
    return (this._comment as CasiUserStoryComment);
  } //public userStory!: UserStory;

  @Input({ required: true }) users: UserModel[] = [];

  @Output() onDeleteComment = new EventEmitter<CasiUserStoryComment>();
  @Output() onSaveComment = new EventEmitter<CasiUserStoryComment>();

  //#endregion

  // @ViewChild("appendTo", { read: ViewContainerRef }) appendTo: ViewContainerRef | undefined;

  currentUser: UserModel | undefined; // = null;
  me: User | null = null;

  loggedInUserId: number | undefined;
  public bottomStart: FabAlign = { vertical: "bottom", horizontal: "start" };
  public footerHtml: SafeHtml = `Wow, man &#128512;!`
  public selectedEmoji: any | undefined = undefined; // { id: 'santa', skin: 3 };
  public editWinOpen: boolean = false;
  public readonlyFlag: boolean = true;
  private eventsSet: boolean = false;

  public data = [
    {
      text: "Edit",
      svgIcon: changeManuallyIcon,
    },
    {
      text: "Delete",
      svgIcon: tableCellDeleteIcon,
    },
  ];

  @ViewChild('hiddenComment') contentEl!: ElementRef;
  @ViewChild('kEditor', { read: ElementRef }) kEditor!: ElementRef;

  public verticalIcon: SVGIcon = moreVerticalIcon;
  form: FormGroup;

  public divHeight!: number

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private meService: MeService,
    private windowService: WindowService,
    public authTokenService: AuthTokenService,
    private popupService: PopupService,
    private fb: FormBuilder,
    private dialogService: DialogService,
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    faIcons.addIcons(...all);
    this.form = this.fb.group({
      id: [null, []],
      user_story_id: [null, []],
      user_id: [null, []],
      first_name: [null, []],
      last_name: [null, []],
      comment: [null, [Validators.required]],
      // attachments: [null, []],
      createdAt: [null, []],
      updatedAt: [null, []]
      // emoji: [null, []]
    })
  }

  //#region NG Event Handlers

  ngOnInit(): void {
    // this.logger.debug('ngOnInit...');
    // this.loggedInUserId = this.meService.userId;
    this._subs.push(this.authTokenService.user$.subscribe(u => {
      this.me = u;
      this.currentUser = this.users.find(us => us.id === this.currentComment.user_id);
      this.loggedInUserId = u?.userId;
      // this.isLoggedInUser = this.isCurrentUser();
      // this.logger.debug('ngOnInit:currentUser:', u);
    }));
  }

  ngOnDestroy(): void {
    // this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }

  ngAfterContentInit(): void {
    // this.logger.debug('ngAfterContentInit...');


  }

  ngAfterViewChecked(): void {

    this.setEvents();

  }

  private setEvents(): void {
    let imgs = Array.from(document.getElementsByClassName('MinImg') as HTMLCollectionOf<HTMLImageElement>);
    var Max = document.getElementById('MaxImg');
    if (imgs && Max && !this.eventsSet){
      for (let i = 0; i < imgs.length; i++) {
          imgs[i].addEventListener('click', function(){

          // transfer the image data

          if (Max && this.src)
            Max.style.backgroundImage="url(" + this.src + ")";

          // make the large image appear
          if (Max)
            Max.style.display="block";
        });
      }

      Max.addEventListener('click', function(){

        // make the large image disappear
        if(Max)
          Max.style.display="none";
      });

      this.eventsSet = true;
    }
  }
  //#endregion

  //#region Form properties

  get f() {
    return this.form.controls;
  }
  get id() {
    return this.form.get('id');
  }
  get user_story_id() {
    return this.form.get('user_story_id');
  }
  get user_id() {
    return this.form.get('user_id');
  }
  get first_name() {
    return this.form.get('first_name');
  }
  get last_name() {
    return this.form.get('last_name');
  }
  get comment() {
    return this.form.get('comment');
  }
  get createdAt() {
    return this.form.get('createdAt');
  }
  get updatedAt() {
    return this.form.get('updatedAt');
  }

  //#endregion

  //#region Public functions

  public valueChange(value: any): void {
    // this.logger.debug(`valueChange...`, value);
    this.form.patchValue({ comment: value });
  }

  public onImageLoaded(args: any): void {
    this.logger.debug('onImageLoaded...', args);
    const { data } = args;
    // this.form.patchValue({ id: data });
    // this.opportunity.id = data;
  }

  public cancelChanges(): void {
    this.logger.debug(`cancelChanges...`, this.form.dirty);
    if (this.form.dirty) {

      const dialogRef = this.dialogService.open({
        content: ConfirmModalComponent,
        minWidth: 320,
        width: 750,
      });

      const contentRef = dialogRef.content.instance as ConfirmModalComponent;
      contentRef.title = "ABANDON CHANGES";
      contentRef.content = `Abandon your changes?`;

      dialogRef.result.subscribe((r: any) => {
        this.logger.debug('cancelChanges:result:', r);
        if (r instanceof DialogCloseResult) {
          return;
        }
        if (r.text === CasiCloseOptions.Ok) {
          this.logger.debug("cancelChanges:ok to proceed... ");
          this.form.reset();
          this.readonlyFlag = true;
        }
        this.eventsSet = false;
        setTimeout(() => this.setEvents());
        this.form.patchValue(this.currentComment);
      });
    } else {
      this.readonlyFlag = true;
      this.eventsSet = false;
      setTimeout(() => this.setEvents());
    }
    // this.form.reset();
    // this.readonlyFlag = true;
    // this.form.patchValue(this.comment);

  }

  public saveChanges(): void {
    this.logger.debug(`saveChanges...`, this.form.value);
    // this.comment.description = this.form.value.description;
    this.readonlyFlag = true;
    this.currentComment = this.form.value;
    this.eventsSet = false;
    this.onSaveComment.emit(this.form.value);
  }

  public togglePopup(anchor: ElementRef | HTMLElement): void {
    if (this.popupRef) {
      this.popupRef.close();
      this.popupRef = undefined;
    } else {
      this.popupRef = this.popupService.open({
        anchor: anchor,
        content: EmojiContentComponent,
      });
    }
  }

  public openEmojiWindow(): void {
    this.logger.debug("openEmojiWindow...");
    this.editWinOpen = true;
  }

  public close(): void {
    this.logger.debug('close...');
    this.editWinOpen = false;
  }

  public onButtonClicked(evnt: any): void {
    this.logger.debug(`onButtonClicked:evnt: `, evnt)
    if (evnt.text === 'Edit') {
      // this.logger.debug('contentEl: ', this.contentEl.nativeElement);
      // this.logger.debug('contentEl:', this.contentEl);
      // this.logger.debug('contentEl: height', this.contentEl.nativeElement.offsetHeight);
      this.divHeight = this.contentEl.nativeElement.offsetHeight;
      this.readonlyFlag = false;
      setTimeout(() => {
        // this.logger.debug('kEditor: ', this.kEditor.nativeElement);
        // this.logger.debug('kEditor:', this.kEditor);
        // this.logger.debug('kEditor: height', this.kEditor.nativeElement.offsetHeight);
        let content = this.kEditor.nativeElement.querySelector('.k-editor-content');
        let toolbar = this.kEditor.nativeElement.querySelector('.k-editor-toolbar');
        let toolbarHeight = toolbar.offsetHeight;
        // this.logger.debug('content:', content);
        // this.logger.debug('toolbar:', toolbar);
        // this.logger.debug('toolbar:height: ', toolbarHeight);
        // content.style.height = this.divHeight;
        // this.renderer.setStyle(content.nativeElement, 'height', `${this.divHeight}px`);
        this.renderer.setStyle(content, 'height', `${this.divHeight + toolbarHeight}px`);
      })
    } else if (evnt.text === 'Delete') {
      this.onDeleteComment.emit(this.currentComment);
    }
  }

  public isLoggedInUser(): boolean {
    return this.loggedInUserId === this.currentUser?.id;
  }

  public addEmoji(evnt: any) {
    this.logger.debug(`addEmoji: `, evnt);
    this.selectedEmoji = evnt.emoji;
  }

  public setEmoji(evnt: any) {
    this.logger.debug(`setEmoji:evnt: `, evnt);
    this.selectedEmoji = evnt;
  }

  public hasUser(): boolean {
    return !!this.currentUser;
  }

  public isCurrentUser(): boolean {
    return this.currentUser?.id === this.currentComment.user_id;
  }

  //#endregion

  //#region Private functions

  //#endregion
}
